import $ from 'jquery';

export default class Messages {
  constructor(element, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          container: '.messages__list',
        },
        classes: {
          active: 'is-active',
          message: 'message',
        },
        timeout: true,
        timeoutDuration: 5000,
      },
      options,
    );

    this.$element = $(element);
    this.$container = $(this.options.selectors.container, this.$element);
    this.container = this.$container.get(0);

    this.bind();
  }

  bind() {
    $(document).on('message', this.handleMessageEvent.bind(this));
    this.$container.on(
      'animationend',
      `.${this.options.classes.message}`,
      this.handleAnimationEnd.bind(this),
    );
  }

  /**
   * @param {Event} event
   */
  handleMessageEvent(event) {
    const {detail} = event;
    const {messages = []} = detail;

    if (!messages) {
      return;
    }

    const messageHtml = messages.map(this.createMessage);
    this.render(messageHtml);
  }

  /**
   * @param {Event} event
   */
  handleAnimationEnd({target}) {
    target.remove();
  }

  handleTimeout(ref) {
    this.setActive(false);
    this.container.removeChild(ref);
  }

  setActive(state = true) {
    this.$container.toggleClass(this.options.classes.active, state);
  }

  createMessage(item) {
    const {text, type = 'info'} = item;

    return $('<li />')
      .addClass(`message message--${type} is-active`)
      .html(`<div><svg class="icon"><use href="#check" xlink:href="#check" /></svg>${text}</div>`)
      .get(0);
  }

  render(messages) {
    messages.forEach(msg => {
      const ref = this.container.appendChild(msg);
      this.setActive();

      if (this.options.timeout) {
        window.setTimeout(
          this.handleTimeout.bind(this, ref),
          this.options.timeoutDuration,
        );
      }
    });
  }
}
